export default __webpack_public_path__ + "static/media/River_Inn_foot.c22be202.png";